module.exports = __webpack_public_path__ + "img/kz_pravo_na_izobrajenie_1.1f1e9f6e.png";